<template>
  <div class="embed-navigation">
  </div>
</template>

<script>
export default {
  name: 'EmbedNavigation',
  props: {
    // Callback opcional a ser executado quando o botão voltar for acionado
    onBack: {
      type: Function,
      default: null
    },
    // Identificador único para este componente (usado nas mensagens)
    identifier: {
      type: String,
      default: 'embedNavigation'
    },
    // Se deve prevenir o comportamento padrão do botão voltar
    preventDefaultBack: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isEmbedded: false
    }
  },
  created () {
    this.checkIfEmbedded()
  },
  mounted () {
    this.setupListeners()
  },
  beforeDestroy () {
    this.removeListeners()
  },
  methods: {
    checkIfEmbedded () {
      try {
        this.isEmbedded = window.self !== window.top
      } catch (e) {
        this.isEmbedded = true
      }
    },

    setupListeners () {
      if (this.isEmbedded) {
        window.addEventListener('message', this.handleParentMessage)
      }

      if (this.preventDefaultBack) {
        window.addEventListener('popstate', this.handlePopState)
      }
    },

    removeListeners () {
      if (this.isEmbedded) {
        window.removeEventListener('message', this.handleParentMessage)
      }

      if (this.preventDefaultBack) {
        window.removeEventListener('popstate', this.handlePopState)
      }
    },

    // Método para lidar com o evento popstate (botão voltar do navegador)
    handlePopState (event) {
      if (this.preventDefaultBack) {
        event.preventDefault()
        this.goBack()
      }
    },

    // Método para lidar com mensagens do container pai
    handleParentMessage (event) {
      if (event.data && event.data.action === 'voltar') {
        this.goBack()
      }
    },

    goBack () {
      if (this.onBack && typeof this.onBack === 'function') {
        const shouldContinue = this.onBack()
        if (shouldContinue === false) {
          return
        }
      }

      if (this.isEmbedded) {
        try {
          window.parent.postMessage({
            action: 'voltar',
            from: this.identifier
          }, '*')
          setTimeout(() => {
            window.history.go(-1)
          }, 100)
        } catch (e) {
          window.history.go(-1)
        }
      } else {
        window.history.go(-1)
      }

      this.$emit('voltar')
    }
  }
}
</script>
